import { useTreatmentHistoryDetailContext } from '@context/TreatmentHistoryDetail';

import * as styles from './styles';

const DeliveryStatus = () => {
  const { deliveryStatusText, deliveryPrice, lastDeliveryPayment } =
    useTreatmentHistoryDetailContext();

  return (
    <div css={styles.container}>
      <div css={styles.column}>
        <div css={styles.title}>배송 상태</div>
        <div css={styles.content}>{deliveryStatusText}</div>
      </div>
      <div css={styles.column}></div>
      <div css={styles.column}></div>
      <div css={styles.column}>
        <div css={styles.title}>배송비</div>
        <div
          css={[
            styles.content,
            lastDeliveryPayment?.paymentStatus === 'fail' && styles.failed
          ]}
        >
          {lastDeliveryPayment?.paymentStatus === 'complete' &&
            typeof deliveryPrice === 'number' &&
            `${deliveryPrice}원`}
          {lastDeliveryPayment?.paymentStatus === 'fail' && ' - 결제 실패'}
        </div>
      </div>
    </div>
  );
};

export default DeliveryStatus;
